import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface AdoptionState {
    elements: AdoptionElement[],
    currentPage: number,
    totalRows: number,
    loading: boolean
}

export interface AdoptionElement {
    _id: string,
    notes: string,
    contribution: number,
    contractSign: boolean,
    statusAdoption: string,
    userId: string,
    dogId: string
}

interface PageableDto {
    page: number;
    size: number;
    sort: string[];
}

export interface GetAllElementPayloadAdoption {
    pageableDto: PageableDto;
}

const initialState: AdoptionState = {
    elements: [],
    currentPage: 0,
    totalRows: 0,
    loading: false
}

export const Adoption = createSlice({
    name: "Adoption",
    initialState,
    reducers: {

        getAllElement: (state, action: PayloadAction<GetAllElementPayloadAdoption>) => {
            state.loading = true;
        },

        getAllElementSuccess: (state, action: PayloadAction<{ data: AdoptionElement[], currentPage: number, totalRows: number }>) => {
            state.elements = action.payload.data;
            state.currentPage = action.payload.currentPage;
            state.totalRows = action.payload.totalRows;
            state.loading = false;
        },
        getAllElementError: (state) => {
            state.loading = false;
        },

        saveElement: (stare, action: PayloadAction<AdoptionElement>) => {
        },
        saveElementSuccess: (state, action: PayloadAction<AdoptionElement>) => {
            state.elements.push(action.payload)
        },
        saveElementError: (state, action: PayloadAction<AdoptionElement>) => {
            state.loading = false;
        },

        updateElement: (state, action: PayloadAction<AdoptionElement>) => {
        },
        updateElementSuccess: (state, actions: PayloadAction<AdoptionElement>) => {
            let index = state.elements.findIndex(element => element.notes === actions.payload.notes)
            state.elements[index] = actions.payload

        },
        updateElementError: (state) => {
            state.loading = false;
        },

        deleteElement: (state, action: PayloadAction<{ id: string, callback: () => void }>) => {
        },
        deleteElementSuccess: (state, action: PayloadAction<string>) => {
        },
        deleteElementError: (state) => {
            state.loading = false;
        },

    }
})

export const {
    getAllElement,
    getAllElementSuccess,
    getAllElementError,
    saveElement,
    saveElementSuccess,
    saveElementError,
    updateElement,
    updateElementSuccess,
    updateElementError,
    deleteElement,
    deleteElementSuccess,
    deleteElementError
} = Adoption.actions

export default Adoption.reducer